<template>
  <Loader :value="promise" class="purchase-data">
    <div class="container view">
      <Card>
        <DataTable
          sticky
          theme="border"
          :value="items"
          :columns="[
            { id: 'key', label: 'Key' },
            { id: 'value', label: 'Value' },
          ]"
        >
          <template #key="{ item }">{{ item.key }}</template>
          <template #value="{ item }">{{ item.value }}</template>
        </DataTable>
      </Card>
    </div>
  </Loader>
</template>

<script>
import fetch from '@/fetch'
import { CopyToClipboard } from '@/utils'

import HeaderComponent from '@/components/Header'
import Card from '@/components/Card'
import DataTable from '@/components/DataTable'

export default {
  props: {
    id: String,
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      data: {},
      promise: null,
    }
  },
  computed: {
    breadcrumbs() {
      return [{ title: this.$metaInfo.title }]
    },
    items() {
      return Object.entries(this.data).map(([k, v]) => ({ key: k, value: v }))
    },
  },
  methods: {
    fetch() {
      this.promise = fetch(`/api/contract/${this.id}/data`)
        .then(res => res.json())
        .then(res => (this.data = res))
    },
    copy(el, value) {
      CopyToClipboard(value)
      let range = document.createRange()
      range.selectNode(el)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
    },
  },
  metaInfo() {
    return {
      title: 'Data',
    }
  },
  components: {
    HeaderComponent,
    Card,
    DataTable,
  },
}
</script>

<style lang="scss">
.purchase-data {
  background-color: $background-grey;

  .data-table__cell {
    align-items: baseline;
  }
}
</style>
